import { webApi } from '@mi-front/api-clients';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { useState } from 'react';
import { useFragment } from '../../../hooks/useFragment';
import { useFragmentSocialUploadsQuery } from '../../social-export-panorama/hooks/useFragmentSocialUploadsQuery';
import { CloneVideoEditionProjectDialog } from '../dialogs/CloneVideoEditionProjectDialog';
import { FragmentVideoEditionsProjectList } from '../projects/FragmentVideoEditionsProjectList';
import { FragmentVideoEditionsProjectsEmptyState } from '../projects/FragmentVideoEditionsProjectsEmptyState';
import { FragmentVideoEditionsStandaloneCreateToolbar } from '../projects/FragmentVideoEditionsStandaloneCreateToolbar';
import { useFragmentVideoEditionsProjectsQuery } from '../hooks/useFragmentVideoEditionsProjectsQuery';

/**
 * Tab content for video editions: lists projects, chip navigation, and clone/create/delete flows.
 */
export function FragmentVideoEditionsTab() {
  const { fragment } = useFragment();
  const [cloneProject, setCloneProject] =
    useState<webApi.EnrichedVideoEditorProjectListItemDto | null>(null);
  const uploadsQuery = useFragmentSocialUploadsQuery(fragment.id);
  const listQuery = useFragmentVideoEditionsProjectsQuery(fragment.id);

  const projects = listQuery.data;
  const showCreateInHeader = projects === undefined || projects.length > 0;

  return (
    <>
      <FragmentVideoEditionsStandaloneCreateToolbar
        fragmentId={fragment.id}
        visible={showCreateInHeader && (projects === undefined || projects.length === 0)}
        currentProjectCount={projects?.length ?? 0}
      />

      <QueryView query={listQuery}>
        {(projects) =>
          !projects.length ? (
            <FragmentVideoEditionsProjectsEmptyState fragmentId={fragment.id} />
          ) : (
            <FragmentVideoEditionsProjectList
              fragmentId={fragment.id}
              projects={projects}
              uploadsByPlatform={uploadsQuery.data}
              onCloneProject={(project) => setCloneProject(project)}
            />
          )
        }
      </QueryView>

      {cloneProject && (
        <CloneVideoEditionProjectDialog
          open={!!cloneProject}
          onClose={() => setCloneProject(null)}
          sourceProject={cloneProject}
        />
      )}
    </>
  );
}
